export enum RouteNames {
    CancelReservation = 'cancelreservation',
    CancelConfirmation = 'cancelconfirmation',
    StayPreferences = 'staypreferences',
    ModifyReservation = 'changereservation',
    ManageYourStay = 'ManageYourStay'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/enums/route-names.enum.ts